import useSWRMutation from 'swr/mutation';
import { DUpdateComplaintLastSeen } from '../data/dtos/last-seen';
import { complaintChatService } from '../services/complaint';

export function useUpdateComplaintUserLastSeen({
  userId,
}: Nullable<DUpdateComplaintLastSeen>) {
  const execute = async () => {
    return await complaintChatService.updateLastSeen({
      userId: userId!,
    });
  };

  const fetchKey = userId ? ['update-complaint-user-last-seen', userId] : null;
  const { isMutating, trigger } = useSWRMutation(fetchKey, execute);

  return {
    trigger,
    isLoading: isMutating,
  };
}
